import { CompareTypeAdapter, CompareVariable } from './compare-type-adapter.model';

const VARIABLES: CompareVariable[] = [
  { key: 'temperature', labelKey: 'variables.temperature', unit: 'ºC', section: 'common' },
];

export const temperatureCompareAdapter: CompareTypeAdapter = {
  type: 'TemperatureMeasurement',
  selectFields: ['name', 'measurementType', 'time', 'temperature'],
  sectionLabelKey: () => 'compare_measurements.sections.common',
  variables: () => VARIABLES,
  buildSeries(m, variable) {
    const values = (m as any)[variable.key];
    const time = (m as any).time;
    if (!Array.isArray(values) || !values.length || !Array.isArray(time) || !time.length) return [];
    return [{ label: m.name as string, time: time.map((x: any) => new Date(x)), values }];
  },
};
